import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";

import "./index.css";
import ApiService, { ICachedData } from "./ApiService";
import LoadingScreen from "./LoadingScreen";
import App from "./App";

import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

const rootElement = document.getElementById("root");
const SHOW_PLACEHOLDER = false;
const PRELOAD_MODEL = false;

THREE.Cache.enabled = true;
// THREE.ImageUtils.crossOrigin = "";

function getUrlParameter(name: string) {
  name = name.replace(/[[]/, "[").replace(/[\]]/, "]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(window.location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

const initialData = { bobbleheads: {}, events: {} };
export let bobbleHeadID: string = "";

function GetBobbleID() : string {
  return bobbleHeadID;
}

ReactGA.initialize("UA-68391578-10");

(async () => {
  if (SHOW_PLACEHOLDER) {
    ReactDOM.render(
      <App
        bobblehead={null}
        initialData={initialData}
        showPlaceholder={true}
      />,
      rootElement
    );
  } else {
    ReactDOM.render(<LoadingScreen />, rootElement);

    const bobbleheadId = getUrlParameter("bid");
    bobbleHeadID = bobbleheadId;
    const data: ICachedData = bobbleheadId
      ? await ApiService.lookup({ bobbleheadIds: [bobbleheadId] })
      : initialData;

    if (data && data.bobbleheads[bobbleheadId]) {
      const bobblehead = data.bobbleheads[bobbleheadId];

      if (PRELOAD_MODEL) {
        new GLTFLoader().load(
          bobblehead.modelUrl,
          () => {
            ReactDOM.render(
              <App bobblehead={bobblehead} initialData={data} />,
              rootElement
            );
          },
          () => {},
          () => {
            ReactDOM.render(
              <App bobblehead={null} initialData={data} />,
              rootElement
            );
          }
        );
      } else {
        ReactDOM.render(
          <App bobblehead={bobblehead} initialData={data} />,
          rootElement
        );
      }
    } else {
      ReactDOM.render(
        <App bobblehead={null} initialData={initialData} />,
        rootElement
      );
    }
  }
})();

export default {
  GetBobbleID
};
